import React, { useContext } from 'react';
import { Table } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { LaunchFeaturesType } from '../../../types/launchFeatures';
import { LAUNCH_FEATURES } from '../../../constants/define/translation';
import { ShowHideColumn } from './column';
import { CommonColumn } from '../shared-column';
import { CountryContext } from '../../../repository/context/countryContext';

interface LaunchFeaturesTableProps {
  records: any;
  onRefresh: () => void;
  loading?: boolean;
  className?: string;
}

const { Column } = Table;
export const LaunchFeaturesTable = (props: LaunchFeaturesTableProps) => {
  const { t } = useTranslation(LAUNCH_FEATURES);
  const { records, loading, className, onRefresh } = props;
  const countryContext = useContext(CountryContext);
  const countries: any[] = countryContext?.countryList?.map(item => {
    return {
      value: item?.code,
      label: item?.name,
    };
  });

  return (
    <>
      <StyledTable dataSource={records} loading={loading} className={className} rowKey="id" pagination={false}>
        <Column
          title={t('table.title.feature')}
          align="center"
          width={100}
          dataIndex="feature"
          key="feature"
          render={value => <CommonColumn value={value} />}
        />

        {countries?.map((country: any) => (
          <Column
            title={country.label}
            align="center"
            width={32}
            dataIndex="show"
            key={country.value}
            render={(_, record: LaunchFeaturesType) => (
              <ShowHideColumn onRefresh={onRefresh} record={record} key={country.value} country={country.value} />
            )}
          />
        ))}

        <Column
          title={t('table.title.description')}
          width={250}
          dataIndex="description"
          key="description"
          render={value => <CommonColumn value={value} />}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)``;
